import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventIssueClosed implements PersistenceEvent {

  public readonly type = SyncEventType.ISSUE_CLOSED;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssueClosed {
    return new EventIssueClosed(payload['issueId'], payload['avatar']);
  }

}

